export const serializeArrayQueryParams = (key: string, arr: Array<string | number | boolean>) => {
	return arr.reduce<string>((prev, arrItem, index) => {
		if (index === 0) {
			prev += `?${key}=${arrItem}`;
		} else {
			prev += `&${key}=${arrItem}`;
		}
		return prev;
	}, "");
};
